import Dropdown from "componentsv2/form/Dropdown";
import { FormattedMessage as FM } from "react-intl";
import { UbicationIcon } from "components/Icons";

export function DeliverySetup({ delivery }) {
  const fieldDelivery = {
    name: "delivery",
    model: "sale.delivery_party",
    recSearch: searchDelivery,
    label: "delivery.panel.delivery",
  };

  async function searchDelivery(value) {
    const dom = [["active", "=", true]];
    if (value && value !== "") {
      dom.push(["rec_name", "ilike", `%${value}%`]);
    }
    return dom;
  }
  return (
    <div className="grow flex flex-col items-center justify-center p-12 text-center bg-zinc-50/50">
      <div className="max-w-md w-full flex flex-col items-center gap-6">
        <div className="w-24 h-24 bg-zinc-200/50 rounded-3xl flex items-center justify-center text-blue-700 shadow-inner">
          <UbicationIcon className="w-6" />
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-2xl font-black text-zinc-800 tracking-tight">
            <p className="mx-auto">
              <FM id="sale.sale.dispatch_today" />
            </p>
          </h3>
          <p className="text-zinc-500 text-base">
            <FM id="sale.sale.dispatch_today_text" />
          </p>
        </div>
        <div className="w-full bg-white p-6 rounded-2xl border border-zinc-200 shadow-xl shadow-zinc-200/50">
          <Dropdown
            field={fieldDelivery}
            model={"sale.delivery_party"}
            readOnly={false}
            name={"delivery"}
            data={delivery}
            label={"delivery.panel.delivery"}
            recSearch={fieldDelivery.recSearch}
          />
        </div>
      </div>
    </div>
  );
}
